import { memo } from "react";

export const AutomationStepArrow = memo(({ className }: { className?: string }) => (
    <svg
        width="10"
        height="37"
        viewBox="0 0 10 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <title>Next step</title>
        <circle cx="5" cy="5" r="4.5" className="fill-surface-popover stroke-border-invert" />
        <path
            d="M5.5 10C5.5 9.72386 5.27614 9.5 5 9.5C4.72386 9.5 4.5 9.72386 4.5 10L5 10L5.5 10ZM4.64645 36.3536C4.84171 36.5488 5.15829 36.5488 5.35355 36.3536L8.53553 33.1716C8.7308 32.9763 8.7308 32.6597 8.53553 32.4645C8.34027 32.2692 8.02369 32.2692 7.82843 32.4645L5 35.2929L2.17157 32.4645C1.97631 32.2692 1.65973 32.2692 1.46447 32.4645C1.2692 32.6597 1.2692 32.9763 1.46447 33.1716L4.64645 36.3536ZM5 10L4.5 10L4.5 36L5 36L5.5 36L5.5 10L5 10Z"
            className="fill-border-invert"
        />
    </svg>
));
AutomationStepArrow.displayName = "AutomationStepArrow";
